module.exports = __webpack_public_path__ + "resources/img/career-welfareImg5.cbe81f78.jpg";